export default __webpack_public_path__ + "static/media/close-icon.51ebba93.svg";